// @ts-strict-ignore
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { LMRouteComponentService } from '@services/lm-route-component.service';
import { SohoDataGridComponent } from 'ids-enterprise-ng';

@Component({
  selector: 'lm-audit-log-compare-dialog',
  standalone: false,
  template: `
    <div soho-datagrid
        [dataset]="dataset"
        data-automation-id="lm-audit-compare-modal-grid-datagrid"
    ></div>
  `,
  // todo assuming this is here so comps in dialogs don't update the current component for the app provided LMRouteComponentService?
  // todo not a big fan, need to find a better way, would rather provide a useFor here that pointed at a stubbed out class.
  providers: [ LMRouteComponentService ]
})
export class LMAuditLogCompareDialogComponent implements OnInit {
  @ViewChild(SohoDataGridComponent, { static: true }) dataGridComponent: SohoDataGridComponent;

  // @Input() dataset: LMAuditCompareChangedValues[];
  @Input() dataset: Object[];

  constructor() { }

  ngOnInit() {
    // Create column data
    const headerColumns: SohoDataGridColumn[] = [
      {
        id: 'FieldName',
        name:  Soho.Locale.translate('FieldName'),
        field:  'FieldName',
        sortable: false,
        formatter: 'Text',
        textOverflow: 'ellipsis',
        minWidth: 200,
        maxWidth: 300
      },
      {
        id: 'Label',
        name:   Soho.Locale.translate('ListLabel'),
        field:  'Label',
        sortable: false,
        formatter: 'Text',
        textOverflow: 'ellipsis',
        minWidth: 200,
        maxWidth: 300
      },
      {
        id: 'FromValue',
        name:   Soho.Locale.translate('OldValue'),
        field:  'FromValue',
        sortable: false,
        formatter: 'Editor',
        minWidth: 200,
        maxWidth: 500
      },
      {
        id: 'ToValue',
        name:  Soho.Locale.translate('NewValue'),
        field: 'ToValue',
        sortable: false,
        formatter: 'Editor',
        minWidth: 200,
        maxWidth: 500
      }
    ];

    // Construct grid options
    const gridOptions: SohoDataGridOptions = <SohoDataGridOptions> {
      columns: headerColumns,
      dataset: this.dataset,
      selectable: false,
      paging: false,
      // stickyHeader: true,
      cellNavigation: true,
      rowNavigation: true,
      enableTooltips: true,
      saveUserSettings:  { columns: true }
    };

    // Now using 'light datagrid header color
    gridOptions['headerBackgroundColor'] = 'light';

    this.dataGridComponent.gridOptions = gridOptions;
  }
}
